// PostingStatusBadge — badge de statut d'affichage (E1d, F-305). Partage liste +
// fiche. i18n via t(`gest:affichages.status.${status}`). Tokens @gs/ui (StatusBadge).

import { StatusBadge } from '@gs/ui';
import { useTranslation } from '../../i18n';
import type { PostingStatus } from '../../hooks/usePostings';
import { POSTING_STATUS_BADGE } from './format';

export function PostingStatusBadge({ status }: { status: PostingStatus }) {
  const { t } = useTranslation();
  return <StatusBadge variant={POSTING_STATUS_BADGE[status]}>{t(`gest:affichages.status.${status}`)}</StatusBadge>;
}
